'use client';
import React from 'react';

const CTABanner: React.FC = () => {
  const handleScrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      className="py-20 relative overflow-hidden"
      style={{ backgroundColor: '#0066CC' }}
      aria-label="Call to action"
    >
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2
          className="mb-6"
          style={{
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 700,
            fontSize: 'clamp(26px, 3.5vw, 40px)',
            color: '#ffffff',
            lineHeight: 1.2,
          }}
        >
          Ready to Connect with Caps N Corks II, LLC?
        </h2>
        <p
          className="mb-10 max-w-2xl mx-auto"
          style={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: '16px',
            color: 'rgba(255,255,255,0.85)',
            lineHeight: 1.8,
          }}
        >
          Whether you have a question, a publishing inquiry, or want to explore a partnership, we are here to help. Reach out today and a member of our team will be in touch promptly.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={() => handleScrollTo('contact')}
            className="inline-flex items-center justify-center px-8 py-4 font-medium uppercase tracking-widest transition-all duration-200 hover:bg-navy-DEFAULT"
            style={{
              backgroundColor: '#122658',
              borderRadius: '7px',
              fontFamily: 'Poppins, sans-serif',
              fontSize: '13px',
              letterSpacing: '2px',
              color: '#ffffff',
            }}
          >
            Request a Callback
          </button>
          <a
            href="tel:+14083873442"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 font-medium uppercase tracking-widest transition-all duration-200 hover:bg-white hover:text-primary-DEFAULT"
            style={{
              backgroundColor: 'transparent',
              border: '2px solid rgba(255,255,255,0.7)',
              borderRadius: '7px',
              fontFamily: 'Poppins, sans-serif',
              fontSize: '13px',
              letterSpacing: '2px',
              color: '#ffffff',
              textDecoration: 'none',
            }}
            aria-label="Call Caps N Corks II at (408) 387-3442"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.4 5.2c.93 1.87 2.53 3.4 4.4 4.4l1.47-1.47c.2-.2.47-.27.67-.13.73.27 1.53.4 2.4.4.4 0 .67.27.67.67v3.33c0 .4-.27.67-.67.67C5.73 13 0 7.27 0 .67 0 .27.27 0 .67 0H4c.4 0 .67.27.67.67 0 .87.13 1.67.4 2.4.13.2.07.47-.13.67L2.4 5.2z" fill="white"/>
            </svg>
            Call (408) 387-3442
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
